import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";
import "./public-home.css";
import "./public-articles.css";

const root = document.querySelector<HTMLDivElement>("#root");
if (!root) throw new Error("Missing application root");

createRoot(root).render(<StrictMode><App /></StrictMode>);
